import styled from "../_snowpack/pkg/@emotion/styled.js";
import React, {useEffect, useRef, useState} from "../_snowpack/pkg/react.js";
import {ArrowRight, X} from "./icons.js";
import {colors, media} from "./theme.js";
import {useGlobalStore} from "../stores/global.js";
import {withAttrs} from "../common/utils.js";
import Button from "./button.js";
import {useWindowDimensions} from "../common/hooks.js";
export default function MainSideBarContainer(props) {
  const {main, title, sidebar, isCart, ...rest} = props;
  const [storeState, setStoreState] = useGlobalStore();
  const {sidebarActive} = storeState;
  const onSidebarClose = () => setStoreState({sidebarActive: false});
  const {height} = useWindowDimensions();
  const [offsetHeight, setOffsetHeight] = useState();
  const ref = useRef(null);
  const sidebarBiggerThanScreen = !!height && !!offsetHeight && height < offsetHeight;
  useEffect(() => {
    if (!ref.current)
      return;
    setOffsetHeight(ref.current.offsetHeight);
  }, [height, ref]);
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, /* @__PURE__ */ React.createElement(LeftCol, null, /* @__PURE__ */ React.createElement(LeftColInner, null, title && /* @__PURE__ */ React.createElement(TitleLeftContainer, null, title), main)), /* @__PURE__ */ React.createElement(RightCol, {
    active: sidebarActive,
    isCart,
    sidebarBiggerThanScreen
  }, /* @__PURE__ */ React.createElement(RightColInner, {
    ref,
    sidebarBiggerThanScreen
  }, title && /* @__PURE__ */ React.createElement(TitleRightContainer, {
    active: sidebarActive
  }, title, /* @__PURE__ */ React.createElement(CloseIcon, {
    onClick: onSidebarClose
  })), sidebar)));
}
export function SidebarToggleButton(props) {
  const {children, ...rest} = props;
  const [storeState, setStoreState] = useGlobalStore();
  const onClick = () => setStoreState({sidebarActive: !storeState.sidebarActive});
  return /* @__PURE__ */ React.createElement(SidebarButtonContainer, {
    onClick,
    ...rest
  }, /* @__PURE__ */ React.createElement(SidebarButtonInner, null, children, /* @__PURE__ */ React.createElement(ArrowRight, null)));
}
const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 330px;
  column-gap: 77px;

  ${media.mobile} {
    display: block;
    position: relative;
  }
`;
const LeftCol = styled.div`
  min-width: 0;
`;
const RightCol = styled.div`
  & > * {
    top: 0;
    //padding-bottom: 100px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  ${({sidebarBiggerThanScreen}) => sidebarBiggerThanScreen && `position: sticky;
          bottom :0px;
          align-self: flex-end;
          margin-top:auto;
        `}
  ${({isCart, active}) => !isCart && `
      ${media.mobile} {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s;
        background: white;
        padding: 16px;
        z-index: 3000;
        padding-bottom: 20px;
        overflow-y: scroll;
        overflow-x: hidden;
        display: grid;

        ${active && `
          opacity: 1;
          pointer-events: auto;
        `}
      }
    `};
`;
const LeftColInner = styled.div``;
const RightColInner = styled(LeftColInner)`
  width: calc(100% + 20px);
  padding-right: 20px;
  position: sticky;
  top: 0;
  ${({sidebarBiggerThanScreen}) => sidebarBiggerThanScreen && `
      position: relative;
      top: auto;
    `}
  ${media.mobile} {
    padding-bottom: 0px !important;
  }
`;
const TitleRightContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  background: ${colors.w};
  position: relative;
  z-index: 1000;

  ${media.mobile} {
    ${({active}) => !active && `display: none;`}
    background: white;
    position: sticky;
    top: 0;
    padding-bottom: 15px;
    h2 {
      display: flex;
      flex-grow: 1;
    }
  }
`;
const TitleLeftContainer = styled.div`
  display: none;
  margin-bottom: 24px;

  ${media.mobile} {
    display: block;
    margin: 16px 0 24px;
  }
`;
const CloseIcon = styled(X)`
  display: none;
  margin-left: auto;
  cursor: pointer;

  ${media.mobile} {
    display: block;
    margin-left: 20px;
  }
`;
const SidebarButtonContainer = styled(withAttrs(Button, {stretch: true, secondary: true, small: true}))`
  color: ${colors.b};
  display: none;
  ${media.mobile} {
    display: block;
  }
`;
const SidebarButtonInner = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
